// @flow
import React from 'react';

type CrumbNameShape = {
    name: string
};
const CrumbName = ({name, ...rest}: CrumbNameShape) => (
    <span {...rest}>{name}</span>
);

export default CrumbName;
